import { gql } from '@apollo/client'

export const MEDICAL_HISTORY_ATTACHMENTS_SECTION_FIELDS = gql`
  fragment MedicalHistoryAttachmentsSectionFields on MedicalHistoryAttachmentsSection {
    id
    name
    checked
    section
    attachments {
      id
      name
      checked
      addedDate
      subcategory
      children {
        id
        name
        checked
        addedDate
        subcategory
      }
    }
  }
`
